import React from "react";
import { Link } from "react-router-dom";
import PaginaEsito from "./esito/PaginaEsito";

// Pagina di esito in italiano, con lo stesso aspetto delle altre pagine di esito
const Error400 = () => (
   <PaginaEsito titolo="Richiesta non valida" variante="danger">
      <p>La richiesta non può essere elaborata.</p>
      <Link className="btn btn-primary btn-add" to="/dashboard">
         Torna alla home
      </Link>
   </PaginaEsito>
);

export default Error400;
